import type { IconData } from '@stacksjs/iconify-core'

export const controlButtonsFastForward2: IconData = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M8 16A8 8 0 1 0 8 0a8 8 0 0 0 0 16M5 4l3 2.4V4l5 4l-5 4V9.6L5 12z\" clip-rule=\"evenodd\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export default controlButtonsFastForward2
